/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.87.2-v202512162326-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import * as models from './models';

/**
 * Column definitions for the Table. A column definition contains all the properties that define each column in the table. 
 */
export interface ColumnDefinitionBulkEditInputV1 {
    /**
     * The optional column id to specify for columns being updated. This must be provided for a column that is being updated. If left blank, a new column will be created.
     */
    "columnId"?: string;
    /**
     * Name of the column. This will be used as the header for this column. It must be unique for this table
     */
    "columnName": string;
    /**
     * The list of rules that determine the resulting value of a column. At least one rule is required
     */
    "columnRules": Array<models.ColumnRuleInputV1>;
    /**
     * The type for the column
     */
    "columnType": ColumnTypeEnum;
    /**
     * The unit of measure for this column. This is only applicable to columns whose type                      is NUMERIC. If provided, this will enforce that data in this column must be in this unit. For                      example, if the user specifies Fahrenheit and the value comes in as Meters, the value will not be                      inserted. If not provided, values with different units will be allowed to be stored and an extra                       column will be added to the generated table for the UOM
     */
    "columnUom"?: string;
    /**
     * The optional description for this column.
     */
    "description"?: string;
    /**
     * The optional display property for this column, defaults to Name if type UUID, otherwise defaults to null.
     */
    "displayProperty"?: string;
    "isGenerated"?: boolean;
    "isHidden"?: boolean;
    "isIndexed"?: boolean;
    /**
     * Whether to sort ascending if sortIndex is provided, defaults to false
     */
    "sortAscending"?: boolean;
    /**
     * The sort index for this column. If not provided, the column is not sorted.
     */
    "sortIndex"?: number;
    /**
     * The output item type for a UUID column. This value will be used to validate against any items that are returned from rules that return items. If the item's type doesn't match the expected output type, the rule will fail. If not provided, the rule will not validate the item type and any output item type will be allowed
     */
    "uuidColumnOutputItemType"?: string;
}

export enum ColumnTypeEnum {
    UUID = 'UUID' as any,
    TEXT = 'TEXT' as any,
    NUMERIC = 'NUMERIC' as any,
    TIMESTAMPTZ = 'TIMESTAMPTZ' as any,
    BOOLEAN = 'BOOLEAN' as any
}
